import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import DialogLoaderButton from "../loader-button/DialogLoaderButton";

interface ConfirmationDialogProps {
  handleValidate: () => void;
  actionButtonText?: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  confirmationMessage?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  handleValidate,
  actionButtonText,
  open,
  setOpen,
  confirmationMessage,
}) => {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Confirmation</DialogTitle>
          <DialogDescription>
            {confirmationMessage || "Êtes-vous sûr de vouloir continuer ?"}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-0">
          <Button
            variant="outline"
            className="mr-2"
            onClick={() => setOpen(false)}
          >
            Annuler
          </Button>
          <DialogLoaderButton
            name={actionButtonText || "Confirmer"}
            handleSubmit={handleValidate}
            isLoading={false}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationDialog;
